import { render } from "./OurLatestArticles.vue?vue&type=template&id=4b1bc143&ts=true"
import script from "./OurLatestArticles.vue?vue&type=script&lang=ts"
export * from "./OurLatestArticles.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__